import React, { memo, useMemo, useCallback } from "react";
import { setLabel } from "./state/label";
const Trigger = /*#__PURE__*/memo(({
  label,
  children
}) => {
  const onMouseEnter = useCallback(() => setLabel(label), [label]);
  const onMouseLeave = useCallback(() => setLabel(), []);
  return useMemo(() => /*#__PURE__*/React.cloneElement(children, {
    onMouseUp: onMouseLeave,
    onMouseEnter,
    onMouseLeave
  }), [children, onMouseEnter, onMouseLeave]);
});
export default Trigger;
//# sourceMappingURL=Trigger.js.map